import { render, staticRenderFns } from "./HelpfulInfoArticle.vue?vue&type=template&id=671ed49b&scoped=true"
import script from "./HelpfulInfoArticle.vue?vue&type=script&lang=js"
export * from "./HelpfulInfoArticle.vue?vue&type=script&lang=js"
import style0 from "./HelpfulInfoArticle.vue?vue&type=style&index=0&id=671ed49b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ed49b",
  null
  
)

export default component.exports